/**
 * Small shared presentational components used across all dashboard views.
 * Extracted from the original App.jsx.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
// @ts-nocheck
import React from 'react';

export const BenchStat = ({ label, value, bench, suffix = "" }) => (
  <div className="bg-bg-raised rounded-lg border border-border-base p-4">
    <div className="text-xs text-fg-muted uppercase tracking-wide font-semibold">{label}</div>
    <div className="text-2xl font-bold text-fg-primary mt-1">{value}{suffix}</div>
    {bench !== undefined && bench !== 0 && (
      <div className={`text-xs font-medium mt-1 ${bench > 0 ? "text-status-success" : "text-status-danger"}`}>
        {bench > 0 ? "▲" : "▼"} {Math.abs(bench).toFixed(1)} vs county
      </div>
    )}
  </div>
);

export const Breadcrumb = ({ items, onNavigate }) => (
  <div className="bg-bg-raised border-b border-border-base px-6 py-3 flex items-center gap-2 text-sm">
    {items.map((item, i) => (
      <div key={i} className="flex items-center gap-2">
        {i > 0 && <span className="text-fg-muted">›</span>}
        {item.action ? (
          <button onClick={() => typeof item.action === "function" ? item.action() : onNavigate(item.action)} className="text-accent-fg hover:text-accent-fg/80 font-medium inline-flex items-center min-h-11 sm:min-h-0 px-1 sm:px-0">
            {item.label}
          </button>
        ) : (
          <span className="text-fg-primary font-semibold">{item.label}</span>
        )}
        {item.mapFile && (
          <a href={`/maps/${item.mapFile}`} target="_blank" rel="noopener noreferrer" className="bg-status-danger-bg/40 text-status-danger px-2 py-0.5 rounded text-xs hover:bg-status-danger-bg/60 inline-flex items-center min-h-11 sm:min-h-0" title="Open Map PDF">
            📍 Map
          </a>
        )}
      </div>
    ))}
  </div>
);

